// eslint-disable-next-line no-unused-vars
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respData: null,
  },
  getters: {
  },
  mutations: {
    GET(state, payload) {
      state.respData = payload
    },
    ADD(state, payload) {
      if (state.respData != null) {
        state.respData.data.unshift(payload)
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max + 1
      } else {
        state.respData.data = [payload]
        state.respData.max = 1
      }
    },
    UPDATE(state, payload) {
      const productIndex = state.respData.data.findIndex(p => p._id === payload._id)
      Object.assign(state.respData.data[productIndex], payload)
    },
    REMOVE(state, id) {
      if (state.respData != null) {
        const ItemIndex = state.respData.data.findIndex(p => p._id === id)
        state.respData.data.splice(ItemIndex, 1)
        // eslint-disable-next-line operator-assignment
        state.respData.max = state.respData.max - 1
      }
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getLanguage({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/root/servicesConfig/getLanguage?id=${item.id}&pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    addLanguage({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('/api/web/root/servicesConfig/addLanguage', item)
          .then(response => {
            commit('ADD', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateJson({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/root/servicesConfig/updateJson', item)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateLanguage({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/root/servicesConfig/updateLanguage', item)
          .then(response => {
            commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    deleteLanguage({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/web/root/servicesConfig/deleteLanguage?id=${item}`)
          .then(response => {
            commit('REMOVE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateToPublicLanguage({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/root/servicesConfig/updateToPublicLanguage', item)
          .then(response => {
            // commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    getSystemInServices({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/root/servicesConfig/getSystemInServices?id=${item.id}&pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    addSystemInServices({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post('/api/web/root/servicesConfig/addSystemInServices', item)
          .then(response => {
            commit('ADD', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateSystemInServices({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/root/servicesConfig/updateSystemInServices', item)
          .then(response => {
            commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    deleteSystemInServices({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/web/root/servicesConfig/deleteSystemInServices?id=${item}`)
          .then(response => {
            commit('REMOVE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updateToPublicSystemInServices({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put('/api/web/root/servicesConfig/updateToPublicSystemInServices', item)
          .then(response => {
            // commit('GET', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
